import type { ConsumptionTraceStatus, SaleTraceStatus } from '../types/otherSales';

// Fase 22C-1: lógica pura de presentación de la trazabilidad de inventario (solo lectura). Se extrae
// del componente para poder probarla sin un renderizador (el proyecto no usa testing-library ni añade
// dependencias). El texto SIEMPRE acompaña al color (accesibilidad: los badges no dependen solo del tono).
export type TraceTone = 'entry' | 'out' | 'neutral' | 'warn';

export interface TraceSummary {
  label: string;
  tone: TraceTone;
  hint: string;
}

export const TRACE_SUMMARY: Record<SaleTraceStatus, TraceSummary> = {
  CONSUMED: { label: 'Inventario consumido', tone: 'out', hint: 'Esta venta descontó insumos del inventario.' },
  REVERSED: { label: 'Inventario restaurado por anulación', tone: 'entry', hint: 'La venta fue anulada y los insumos descontados se restauraron.' },
  NO_RECIPE: { label: 'Sin afectación de inventario', tone: 'neutral', hint: 'Ningún producto de esta venta tiene receta asignada, por lo que no afecta inventario.' },
  HISTORICAL_NO_TRACE: { label: 'Venta sin trazabilidad de inventario', tone: 'neutral', hint: 'Esta venta no registró afectación de inventario: fue creada antes de habilitarse la trazabilidad automática, o ninguno de sus productos tiene receta asignada.' },
  NOT_APPLICABLE: { label: 'Registro financiero sin líneas de producto', tone: 'neutral', hint: 'Este registro no tiene líneas de producto, por lo que no afecta inventario.' },
  INCONSISTENT: { label: 'Revisión requerida', tone: 'warn', hint: 'La trazabilidad de inventario de esta venta requiere revisión.' },
};

// P-074: un estado que esta versión no conoce (un servidor más nuevo) no tumba la pantalla (revisión
// independiente de P-074, R-04; la misma caída que P-073 encontró con APPROXIMATE en el costeo).
const UNKNOWN_TRACE: TraceSummary = { label: 'Revisión requerida', tone: 'warn', hint: 'Esta versión de la app no reconoce el estado de la trazabilidad de esta venta.' };

export function traceSummary(status: SaleTraceStatus): TraceSummary {
  return TRACE_SUMMARY[status] ?? UNKNOWN_TRACE;
}

// Etiqueta por consumo (texto + tono; nunca depende solo del color).
export function consumptionStatusLabel(status: ConsumptionTraceStatus): { label: string; tone: TraceTone } {
  switch (status) {
    case 'CONSUMED': return { label: 'Descontado', tone: 'out' };
    case 'REVERSED': return { label: 'Revertido', tone: 'entry' };
    case 'INCONSISTENT': return { label: 'Revisión requerida', tone: 'warn' };
    default: return { label: 'Revisión requerida', tone: 'warn' };
  }
}
